import { ensureKeys } from '@/common/react';
import { Logo } from '@/components/logo';
import { FileRoutesByTo } from '@/routeTree.gen';
import { Button, Flex, Text } from '@mantine/core';
import { IconArrowNarrowLeft } from '@tabler/icons-react';
import { useNavigate } from '@tanstack/react-router';
import { PropsWithChildren } from 'react';
import styles from './header.module.css';

type HeaderParentProps = {
	backTo?: keyof FileRoutesByTo;
} & (
	| {
			title?: string;
			showLogo?: never;
	  }
	| {
			showLogo: boolean;
			title?: never;
	  }
);

export type HeaderProps = PropsWithChildren<HeaderParentProps>;

export const Header = ({ backTo, title, showLogo, children }: HeaderProps) => {
	const navigate = useNavigate();
	return (
		<Flex
			justify="space-between"
			w="100%"
			align="center"
			h="85px"
			className={styles.container}
			px="xl"
			c="blue.9"
		>
			{(backTo || title || showLogo) && (
				<Flex align="center">
					{backTo && (
						<Button
							leftSection={<IconArrowNarrowLeft />}
							variant="transparent"
							c="blue.9"
							p="0"
							onClick={() => navigate({ to: backTo })}
						/>
					)}
					{title && <Text className={styles.title}>{title}</Text>}
					{showLogo && <Logo />}
				</Flex>
			)}
			{ensureKeys(children)}
		</Flex>
	);
};
